import { parseTimeOnly } from '@gettactic/api';
import { differenceInHours } from 'date-fns';

export function calculateHoursDifference(open: string, close: string) {
  const dateFromOpenString = parseTimeOnly(open);
  const dateFromCloseString = parseTimeOnly(close);
  return differenceInHours(dateFromCloseString, dateFromOpenString, {
    roundingMethod: 'ceil'
  });
}
